/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * プレスリリース位置情報(都道府県)
 * @export
 * @interface PressReleasePrefecture
 */
export interface PressReleasePrefecture {
    /**
     * 
     * @type {string}
     * @memberof PressReleasePrefecture
     */
    prefId: string;
    /**
     * 
     * @type {string}
     * @memberof PressReleasePrefecture
     */
    prefName: string;
}

export function PressReleasePrefectureFromJSON(json: any): PressReleasePrefecture {
    return PressReleasePrefectureFromJSONTyped(json, false);
}

export function PressReleasePrefectureFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressReleasePrefecture {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'prefId': json['pref_id'],
        'prefName': json['pref_name'],
    };
}

export function PressReleasePrefectureToJSON(value?: PressReleasePrefecture | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pref_id': value.prefId,
        'pref_name': value.prefName,
    };
}

